import { Injectable } from '@angular/core';

import { PouchdbService } from '../../shared/pouchDb.service'
import * as _ from 'lodash';
import { ShelfValues, bookCategoeyEnums } from '../../shared/models/shelfEnums';

import { Constants } from '../../shared/models/constants'
import { Shelf } from '../../shared/models/shelf';
import { Book } from '../../shared/models/book';
import { BookData } from '../../shared/models/bookData';
import { Page } from '../../shared/models/page';
import { LiquidModel } from '../../shared/models/liquidModel';
import { PageContent } from '../../shared/models/pageContent';
import { Recents } from '../../shared/models/recents';
import { BookTemplates } from '../../shared/models/bookTemplates';
import { Debugger } from 'electron';
import { ShelfPouchDb } from '../shelf.pouchdb.service';
import { BehaviorSubject } from 'rxjs/Rx';
@Injectable()
export class InboxPouchService {
    localDB; remoteDB;
    bookTemplates;

    coverObject: any;
    backObject: any;
    constructor(public pouchService: PouchdbService, public ShelfPouchDbService: ShelfPouchDb) {
        this.localDB = this.pouchService.localDB;
        this.remoteDB = this.pouchService.remoteDB;

    }

    ngOnInit() {


    }

    private downloadNextBookInAllDownload = new BehaviorSubject<any>([]);
    downloadNextBookInAllDownload$ = this.downloadNextBookInAllDownload.asObservable();



    retunedexportObj: any;


    // public replicateDocs = [];


    addContentToBook(contentFile, data) {

        this.localDB = this.pouchService.localDB;
        this.remoteDB = this.pouchService.remoteDB;

        var self = this;


        this.pouchService.localDB.find({
            selector: { type: 'book', bId: data.book.bId },
        }).then(function (result) {

            if (data.book.bookCategory == 1) {

                if (result.docs.length > 0) {
                    self.pouchService.localDB.get(result.docs[0]._id).then(function (doc) {
                        return self.pouchService.localDB.remove(doc._id, doc._rev);
                    }).then(function (result) {
                        // handle result
                        console.log(result);
                        self.createExportedBook(contentFile, data);
                    }).catch(function (err) {
                        console.log(err);
                    });


                }

                else {
                    self.createExportedBook(contentFile, data);

                }

            }

            else {

                if (result.docs.length > 0) {

                    self.pouchService.localDB.find({
                        selector: { type: 'bookData', _id: result.docs[0].bookDataDocId },
                    }).then(function (result) {

                        if (result.docs.length > 0) {

                            self.prepareBookdataObj(contentFile, result.docs[0]);


                            return self.pouchService.localDB.put(result.docs[0]).then(function (result) {

                            }).catch(function (err) {

                            })

                        }


                    }).catch(function (err) {
                    });

                }

                else if (result.docs.length == 0) {

                    self.createExportedBook(contentFile, data)
                }
            }

        }).catch(function (err) {
        });

    }
    createExportedBook(contentfile, data) {

        var book = data.book;
        var bookObj = new Book();
        // bookObj.url = book.previewUrl;
        bookObj.url = book.url;
        bookObj.bookCategory = book.bookCategory;
        bookObj.bookType = book.bookType;

        // if (bookObj.bookType == 0) {
        //     if (bookObj.url == "" || bookObj.url == undefined || bookObj.url == 'undefined') {
        //         bookObj.url = "http://hyd.semanooor.com/NooorM/Pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Pdf.pdf";
        //     }
        // }


        bookObj.owner = Constants.USER;
        bookObj.bId = book.bId;
        bookObj._id = Constants.USER + "." + bookObj.bId + ".book";
        bookObj.title = book.title;
        bookObj.coverPage = book.coverPage;
        bookObj.author = book.author;
        bookObj.description = book.description;
        bookObj.downloadUrl = book.downloadUrl;
        bookObj.price = book.price;
        bookObj.language = book.language;
        bookObj.pageCount = book.pageCount;
        bookObj.templateId = book.templateId;
        bookObj.templateId = book.templateId;
        bookObj.isCustomTemplate = book.isCustomTemplate;

        var bookDataObj = new BookData();
        bookDataObj._id = Constants.USER + "." + bookObj.bId + ".bookData";
        bookDataObj.bookDocId = bookObj._id;

        bookObj.bookDataDocId = bookDataObj._id;
        bookDataObj.pages = [];
        var self = this;

        if (bookObj.bookCategory == 1) {
            this.prepareCEBookdataObj(contentfile, bookDataObj, bookObj.bookType)
        }

        else
            this.prepareBookdataObj(contentfile, bookDataObj)

        bookDataObj.lastOpenedPage = bookDataObj.pages[0];
        self.pouchService.localDB.find({
            selector: { type: 'shelf', category: bookObj.bookCategory },
        }).then(function (doc) {

            if (doc.docs[0].bookIds.indexOf(bookObj._id) == -1) {
                // doc.docs[0].bookIds.push(bookObj._id);
                doc.docs[0].bookIds.splice(0, 0, bookObj._id);

            }
            return self.pouchService.localDB.put(doc.docs[0]).then(function (result) {

                var docs = [];
                docs.push(doc.docs[0]._id);
                // self.pouchService.callToReplicateBookAndContentDocs(docs);
            });


        }).then(function (response) {
        }).catch(function (err) {
            console.log(err);
        });



        self.pouchService.localDB.put(bookObj).then(function (response) {
            console.log("dadas");


            // self.replicateDocs.push(bookObj._id);

            self.pouchService.localDB.find({
                selector: { type: 'bookData', _id: bookDataObj._id },
            }).then(function (doc) {


                self.modifyAnfPutBookdataObj(doc, bookObj, bookDataObj);


            }).then(function (response) {
            }).catch(function (err) {
                console.log(err);
            });


        }).catch(function (err) {
            console.log(err);
        });
    }


    // callToReplicateExportDocs(replicateDocs) {

    //     // this.pouchService.callToReplicateBookAndContentDocs(replicateDocs);
    // }

    modifyAnfPutBookdataObj(doc, bookObj, bookDataObj) {
        var self = this;
        if (bookObj.bookCategory == 1) {

            if (doc.docs.length) {

                self.pouchService.localDB.get(doc.docs[0]._id).then(function (doc) {
                    return self.pouchService.localDB.remove(doc._id, doc._rev);
                }).then(function (result) {
                    // handle result
                    console.log(result);


                    self.pouchService.localDB.put(bookDataObj).then(function (result) {

                        // self.replicateDocs.push(bookDataObj._id);
                        // self.callToReplicateExportDocs(self.replicateDocs);

                    }).catch(function (err) {

                    });

                }).catch(function (err) {
                    console.log(err);
                });

            }

            else {
                self.pouchService.localDB.put(bookDataObj).then(function (result) {
                    // self.replicateDocs.push(bookDataObj._id);
                    // self.callToReplicateExportDocs(self.replicateDocs);

                }).catch(function (err) {

                });
            }
        }

        else {
            if (doc.docs.length) {
                bookDataObj["_rev"] = doc.docs[0]._rev;
                return self.pouchService.localDB.put(doc.docs[0]).then(function (result) {
                    // self.replicateDocs.push(bookDataObj._id);
                    // self.callToReplicateExportDocs(self.replicateDocs);

                }).catch(function (err) {

                });;
            }
            else {

                self.pouchService.localDB.put(bookDataObj).then(function (result) {
                    // self.replicateDocs.push(bookDataObj._id);
                    // self.callToReplicateExportDocs(self.replicateDocs);

                }).catch(function (err) {

                });
            }

        }

        self.downloadNextBookInAllDownload.next('downloaded');


        // sefl.updateInboxData.next()

        // self.ShelfPouchDbService.getShelfData(parent.window.document["mycompthis"], 0)
        self.ShelfPouchDbService.getShelfData(parent.window.document["mycompthis"], 0);


    }

    prepareCEBookdataObj(contentfile, bookDataObj, type) {

        for (var i = 0; i < contentfile.page.length; i++) {

            if (bookDataObj[contentfile.page[i].id]) {

                for (var j = 0; j < contentfile.page[i].enrichment_page.length; j++) {
                    bookDataObj[contentfile.page[i].id].enrichment_page.push(contentfile.page[i].enrichment_page[j])
                }

            }

            else {

                if (type == 0 || type == 1) {


                    if (i == 0) {

                        this.coverObject = _.filter(contentfile.page, function (o) { return o.title == "Cover Page" });
                        bookDataObj.pages.push(this.coverObject[0].id);
                        bookDataObj[this.coverObject[0].id] = this.coverObject[0];

                        this.backObject = _.filter(contentfile.page, function (o) { return o.title == "End Page" });
                        bookDataObj.pages.push(this.backObject[0].id);

                        bookDataObj[this.backObject[0].id] = this.backObject[0];
                    }

                    if (contentfile.page[i].title != "Cover Page") {

                        if (contentfile.page[i].title != "End Page") {
                            bookDataObj[contentfile.page[i].id] = contentfile.page[i];
                            bookDataObj.pages.splice(bookDataObj.pages.length - 1, 0, contentfile.page[i].id);
                        }


                    }

                }

                else {
                    bookDataObj.pages.push(contentfile.page[i].id);
                    bookDataObj[contentfile.page[i].id] = contentfile.page[i];
                }

            }

        }

        this.makePageObj(contentfile);
    }

    prepareBookdataObj(contentfile, bookDataObj) {

        for (var i = 0; i < contentfile.page.length; i++) {

            if (bookDataObj[contentfile.page[i].pageNumber]) {

                for (var j = 0; j < contentfile.page[i].enrichment_page.length; j++) {


                    for (var k = 0; k < bookDataObj[contentfile.page[i].pageNumber].enrichment_page.length; k++) {

                        var data = bookDataObj[contentfile.page[i].pageNumber].enrichment_page[k];

                        if (bookDataObj[contentfile.page[i].pageNumber].enrichment_page[k].id == contentfile.page[i].enrichment_page[j].id) {

                            bookDataObj[contentfile.page[i].pageNumber].enrichment_page[k] = contentfile.page[i].enrichment_page[j];
                        }

                        else {

                            bookDataObj[contentfile.page[i].pageNumber].enrichment_page.push(contentfile.page[i].enrichment_page[j])
                        }
                    }

                }

            }

            else {

                bookDataObj[contentfile.page[i].pageNumber] = contentfile.page[i];

                bookDataObj.pages.push(contentfile.page[i].pageNumber)

            }

        }

        this.makePageObj(contentfile);

    }

    public isPageObjAdjust: any

    makePageObj(contentfile) {

        var self = this;

        // for(var i=0;i<contentfile.content.length;i++){
        this.isPageObjAdjust = 0;

        this.iterateToCheckandDeletePageobj(contentfile.content[0], contentfile);
    }

    iterateToCheckandDeletePageobj(file, contentfile) {
        var self = this;
        this.checkAndDeletePageobj(file, self.isPageObjAdjust).then(function (result) {
            // this.checkAndDeletePageobj(contentfile.content[result],result)

            self.isPageObjAdjust = result;


            if (result == contentfile.content.length) {

                self.putPageobjDocuments(contentfile);
            }
            if (contentfile.content[self.isPageObjAdjust]) {

                self.iterateToCheckandDeletePageobj(contentfile.content[self.isPageObjAdjust], contentfile)

            }

        }).catch(function (err) {


        })
    }

    checkAndDeletePageobj(data, index) {

        var self = this;
        return new Promise((resolve, reject) => {

            self.pouchService.localDB.find({
                selector: { _id: data._id },
            }).then(function (result) {
                if (result.docs.length > 0) {

                    return self.pouchService.localDB.remove(result.docs[0]._id, result.docs[0]._rev).then(function (result) {

                        resolve(index + 1);
                    });

                }

                else {

                    resolve(index + 1);
                }

            }).catch(function (err) {

            });
        });
    }


    putPageobjDocuments(contentfile) {

        var self = this;

        this.pouchService.localDB.bulkDocs(contentfile.content, function (err, response) {
            if (err) {
                return console.log(err);
            } else {
                console.log("Documents created Successfully");

                var pageObjIdArray = []

                _.forEach(contentfile.content, function (content) {
                    pageObjIdArray.push(content._id);

                })

                // self.callToReplicateExportDocs(pageObjIdArray);

            }
        }).then(function (result) {
        }).catch(function (err) {
        })
    }

    getBookdata(id) {

        var self = this;
        this.localDB = this.pouchService.localDB;
        this.remoteDB = this.pouchService.remoteDB;

        return new Promise((resolve, reject) => {

            self.pouchService.localDB.find({
                selector: { type: 'bookData', _id: id },
            }).then(function (result) {
                if (result.docs.length > 0) {
                    resolve(result.docs[0]);
                }
            }).catch(function (err) {

            });
        });
    }

    pushInboxIdsDoc(doc) {
        this.localDB = this.pouchService.localDB;
        this.remoteDB = this.pouchService.remoteDB;
        var self = this;


        this.pouchService.localDB.find({
            selector: { type: 'inboxBids' },
        }).then(function (result) {
            if (result.docs.length == 0)

                self.pouchService.localDB.put(doc).then(function (result) {

                    // self.pouchService.replicateExportDoc(doc._id);
                });

            else {

                doc._rev = result.docs[0]._rev;

                return self.pouchService.localDB.put(doc).then(function (result) {

                    // self.pouchService.replicateExportDoc(doc._id);
                });


            }

        }).then(function (response) {
        }).catch(function (err) {
            console.log(err);
        });
    }

    finInboxBids() {

        this.localDB = this.pouchService.localDB;
        this.remoteDB = this.pouchService.remoteDB;
        var self = this;
        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'inboxBids' },
            }).then(function (doc) {

                resolve(doc.docs[0]);

            }).catch(function (err) {
                console.log(err);
            });

        });
    }


    openExportedBook(data) {
        var self = this;
        this.localDB = this.pouchService.localDB;
        this.remoteDB = this.pouchService.remoteDB;
        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'book', bId: data.bId },
            }).then(function (doc) {

                resolve(doc.docs[0]);


            }).catch(function (err) {
                console.log(err);
            });

        });
    }

    prepareExportDataObject(data, exportedObject) {

        return new Promise((resolve, reject) => {
            var exportBooksArray = [];
            var exportArray = [];

            for (var key in data) {

                if (data[key])

                    if (data[key]['bids']) {

                        var obj = {
                            "bids": [],
                            "senders": '',
                            "tmp_inbox": '',
                            "bookid": key,
                            "exportsCount": 0,
                            "book": {
                                'title': 'book'
                            }
                        }

                        for (var exportKey in data[key]['bids']) {
                            // var exportObj = {}
                            for (var l = 0; l < exportedObject.length; l++) {
                                if (exportKey == exportedObject[l]._id) {

                                    var exportObj = exportedObject[l];

                                }

                            }

                            if (exportObj) {
                                exportObj['isDownloaded'] = data[key]['bids'][exportKey]['isDownloaded'];
                                exportObj['isDeleted'] = data[key]['bids'][exportKey]['isDeleted'];
                                exportObj['shareCount'] = data[key]['bids'][exportKey]['shareCount'];

                                obj.bids.push(exportObj);
                            }


                        }

                        for (var k = 0; k < data[key]['senders'].length; k++) {

                            if (k == 0)

                                obj.senders = data[key]['senders'][k];
                            if (k > 0) {

                                if (obj.senders != data[key]['senders'][k])

                                    obj.senders = ',' + obj.senders + data[key]['senders'][k];
                            }

                        }


                        obj.tmp_inbox = data[key]['tmp_inbox'];
                        obj.exportsCount = obj.bids.length;
                        // obj['book'] 
                        exportArray.push(obj);

                        for (var i = 0; i < exportArray.length; i++) {


                            for (var f = 0; f < exportedObject.length; f++) {

                                if (exportArray[i].bookid == exportedObject[f].book._id) {

                                    exportArray[i].book = exportedObject[f].book;
                                }
                            }
                        }
                    }

            }

            resolve(exportArray);
        });
    }

}  


// WEBPACK FOOTER //
// ./src/app/shelf/inbox/inbox.pouchdb.service.ts